import SectionTitle from "./SectionTitle";
import RegisterLink from "../../../components/RegisterLink";
import type { ReactNode } from "react";

import monthlyDepositCompetitionImg from "../../../assets/bonuses/monthly-deposit-competition.jpg";
import weeklyCommission6Img from "../../../assets/bonuses/weekly-commission-6.png";
import weeklyRebate5Img from "../../../assets/bonuses/weekly-rebate-5.png";
import specialRebateAud50Img from "../../../assets/bonuses/special-rebate-bonus-aud50.png";
import vvipBonus100Img from "../../../assets/bonuses/vvip-bonus-100.png";
import dailyBonus50Img from "../../../assets/bonuses/daily-bonus-50.png";
import facebookBonusAud38Img from "../../../assets/bonuses/facebook-bonus-aud38.png";
import depositProgressiveAud61to99Img from "../../../assets/bonuses/deposit-progressive-bonus-aud61-99.png";
import welcomeBonus50Img from "../../../assets/bonuses/welcome-bonus-50.png";

type Promo = {
  key: string;
  imageSrc: string;
  imageAlt: string;
  bullets?: ReactNode[];
  variant?: "default" | "monthly";
};

const promos: Promo[] = [
  {
    key: "monthly-deposit-competition",
    imageSrc: monthlyDepositCompetitionImg,
    imageAlt: "Monthly competition deposit ranking",
    variant: "monthly",
    bullets: [
      "This Event Runs From The 1st Feb Day To The Last Day Of Each Month Based On Syd/Melb Time.",
      "Ranking Is Calculated Based On Total Deposit Amount Only.",
      "The More You Deposit During The Month, The Higher Your Ranking.",
      "Rewards Will Be Settled And Distributed After The End Of Each Month's Competition.",
    ],
  },
  {
    key: "weekly-commission-6",
    imageSrc: weeklyCommission6Img,
    imageAlt: "Weekly commission 6%",
    bullets: [
      "6% Weekly Commission Will Be Automatic Issued Every Monday (12:00:00 Pm) To Eligible ACE96AU Members.",
      "The Amount Of The Weekly Commission Is Based On The Total Deposit Minus Total Withdrawal Of Your All Downline Between This Week.",
      "Minimum Withdraw 28AUD Max Withdraw 599 AUD",
      "Only For Slot Games",
      "Cannot Combine With Other Promotion, Deposit, Rebate Or Commission",
      "Strictly NO Saving Of Free Games",
      "This Promotion Can Be Claimed Only 1 (ONE) Time Per Member/IP/Household",
    ],
  },
  {
    key: "weekly-rebate-5",
    imageSrc: weeklyRebate5Img,
    imageAlt: "Weekly rebate 5%",
    bullets: [
      "5% Rebate Will Be Automatic Issued Every Monday (00:00:00 Am Till 00:15:00 Am) To Eligible ACE96AU Members.",
      "The Amount Of The Weekly Rebate Is Based On The Total Deposit Minus Total Withdrawal In The Day (00:00:00 Am Till 23:59:59).",
      "Minimum Withdraw 28AUD Max Withdraw 596 AUD",
      "Only For Slot Games",
      "Cannot Combine With Other Promotion, Deposit, Rebate Or Commission",
      "Strictly NO Saving Of Free Games",
      "This Promotion Can Be Claimed Only 1 (ONE) Time Per Member/IP/Household",
    ],
  },
  {
    key: "special-rebate-aud50",
    imageSrc: specialRebateAud50Img,
    imageAlt: "Special rebate bonus AUD50",
    bullets: [
      "Limited to 1 claim per day",
      <>
        Vip Special Rebate: <span className="text-emerald-400 font-semibold">50AUD</span>
      </>,
      "Bonus Rules : Yesterday Deposit Total 50 AUD",
      "Minimum Withdraw 500 AUD",
      "Max Withdraw 10 AUD",
      "Only For Event Slot Games",
      "Cannot Combine With Other Promotion, Deposit, Rebate Or Commission",
      "Strictly NO Saving Of Free Games",
      "This Promotion Can Be Claimed Only 1 (ONE) Time Per Member/IP/Household",
    ],
  },
  {
    key: "vvip-bonus-100",
    imageSrc: vvipBonus100Img,
    imageAlt: "VVIP bonus 100%",
    bullets: [
      <>
        All Member <span className="text-emerald-400 font-semibold">Can Claim One Time Vvip Bonus.</span>
      </>,
      <>
        Minimum Deposit <span className="text-amber-300 font-semibold">Only 10Aud</span>
      </>,
      "Minimum Withdraw Turnover X5 Can Withdraw",
      "Only Can Play Specify Slot Game",
      <>
        <span className="text-red-500 font-bold mr-1">✘</span> Live Game And Fishing Game
      </>,
      <>
        Example :{" "}
        <span className="text-emerald-400 font-semibold">Deposit 100Aud Can Get 100Aud Bonus =200Aud</span>
      </>,
      "Max Withdraw Deposit Amount X30",
      "Cannot Combine With Other Promotion, Deposit, Rebate Or Commission",
      "Strictly NO Saving Of Free Games",
      "This Promotion Can Be Claimed Only 1 (ONE) Time Per Member/IP/Household",
    ],
  },
  {
    key: "daily-bonus-50",
    imageSrc: dailyBonus50Img,
    imageAlt: "Daily bonus 50%",
    bullets: [
      <>
        Minimum Deposit <span className="text-emerald-400 font-semibold">100 Aud</span>
      </>,
      <>
        Max Bonus <span className="text-amber-300 font-semibold">Payout 300 Aud</span>
      </>,
      "Minimum Winover X5",
      "Only Can Play Slot Game",
      <>
        <span className="text-red-500 font-bold mr-1">✘</span> Live Game And Fishing Game
      </>,
      "Claim Bonus Before Enter Game",
      "Cannot Combine With Other Promotion, Deposit, Rebate Or Commission",
      "Strictly NO Saving Of Free Games",
      "This Promotion Can Be Claimed Only 1 (ONE) Time Per Member/IP/Household",
    ],
  },
  {
    key: "facebook-bonus-aud38",
    imageSrc: facebookBonusAud38Img,
    imageAlt: "Facebook bonus AUD38",
    bullets: [
      <>
        Contact Live Chat <span className="text-emerald-400 font-semibold">Link</span>
      </>,
      <>
        Claim Limit <span className="text-amber-300 font-semibold">2 Time Per Day</span>
      </>,
      "Hit 200 Credit And Withdraw AUD15",
      "Send Screenshot To Livechat To Verify Claim Bonus",
      "Only For Event Games",
      "Cannot Combine With Other Promotion, Deposit, Rebate Or Commission",
      "Strictly NO Saving Of Free Games",
      "This Promotion Can Be Claimed Only 1 (ONE) Time Per Member/IP/Household",
    ],
  },
  {
    key: "deposit-progressive-aud61-99",
    imageSrc: depositProgressiveAud61to99Img,
    imageAlt: "Deposit progressive bonus AUD61-99",
    bullets: [
      <>
        Accumulate Deposit{" "}
        <span className="text-emerald-400 font-semibold">$1000 Aud To Apply This Bonus</span>
      </>,
      <>
        Deposit Accumulate Will Be{" "}
        <span className="text-amber-300 font-semibold">Reset Daily 12AM (Syd/Melb Time).</span>
      </>,
      "Hit Over 1000 Credit To Withdraw Aud 188",
      "Only For Event Slot Games",
      "Cannot Combine With Other Promotion, Deposit, Rebate Or Commission",
      "Strictly NO Saving Of Free Games",
      "This Promotion Can Be Claimed Only 1 (ONE) Time Per Member/IP/Household",
    ],
  },
  {
    key: "welcome-bonus-50",
    imageSrc: welcomeBonus50Img,
    imageAlt: "Welcome bonus 50%",
    bullets: [
      <>
        For New Member <span className="text-emerald-400 font-semibold">Claim Once(1) Only.</span>
      </>,
      <>
        Minimum Deposit <span className="text-amber-300 font-semibold">50 Aud</span>
      </>,
      "Max Bonus Payout Aud400",
      "Only Can Play Slot Game",
      <>
        <span className="text-red-500 font-bold mr-1">✘</span> Live Game And Fishing Game
      </>,
      "Minimum Withdraw Turnover X6",
      "Cannot Combine With Other Promotion, Deposit, Rebate Or Commission",
      "Strictly NO Saving Of Free Games",
      "This Promotion Can Be Claimed Only 1 (ONE) Time Per Member/IP/Household",
    ],
  },
];

function BulletList({ bullets }: { bullets: ReactNode[] }) {
  return (
    <ul className="space-y-2">
      {bullets.map((t, idx) => (
        <li key={idx} className="flex gap-2 text-slate-200 text-xs leading-relaxed">
          <span className="mt-[2px] text-slate-100">✶</span>
          <span>{t}</span>
        </li>
      ))}
    </ul>
  );
}

function PromoCard({ promo }: { promo: Promo }) {
  const baseCard =
    "rounded-2xl overflow-hidden border border-white/10 bg-white/[0.03] shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_10px_35px_rgba(0,0,0,0.35)]";

  const isMonthly = promo.variant === "monthly";

  return (
    <div className={`${baseCard} h-full flex flex-col`}>
      {/* Banner: mobile = full image (no crop); md+ = fixed band with object-contain */}
      <div
        className={
          isMonthly
            ? "relative w-full bg-[#050f24]"
            : "relative w-full shrink-0 bg-[#050f24] md:flex md:h-[168px] lg:h-[188px] md:items-center md:justify-center md:overflow-hidden"
        }
      >
        <img
          src={promo.imageSrc}
          alt={promo.imageAlt}
          className={
            isMonthly
              ? "w-full h-auto block object-contain object-center"
              : "w-full h-auto block object-contain object-center md:mx-auto md:max-w-full md:w-auto md:max-h-[168px] lg:max-h-[188px]"
          }
          loading="lazy"
        />
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/50 to-transparent md:from-black/60"
          aria-hidden
        />
      </div>

      {isMonthly ? (
        <div className="p-4 md:p-5">
          <div className="rounded-xl overflow-hidden border border-white/10 bg-white/[0.04]">
            <div className="bg-white/10 text-slate-100 text-center text-sm font-semibold py-2">
              Monthly Total Deposit Competition
            </div>
            <div className="p-3">
              {promo.bullets?.length ? <BulletList bullets={promo.bullets} /> : null}
              <div className="flex justify-center mt-4">
                <RegisterLink
                  trackLabel="bonuses-ranking"
                  className="px-5 py-2 rounded-full text-sm font-semibold text-slate-900 inline-flex items-center justify-center"
                  style={{
                    background: "linear-gradient(180deg, rgba(196,181,253,1), rgba(99,102,241,1))",
                    boxShadow: "0 8px 24px rgba(99,102,241,0.35)",
                  }}
                >
                  Check Your Ranking Here
                </RegisterLink>
              </div>
            </div>
          </div>

          <div className="mt-4 rounded-xl overflow-hidden border border-white/10">
            <div className="grid grid-cols-2 bg-white/10 text-slate-100 text-sm font-semibold">
              <div className="py-2 text-center border-r border-white/10">Ranking</div>
              <div className="py-2 text-center">Cash Prize</div>
            </div>
            {[
              ["#1", "AUD 1999"],
              ["#2", "AUD 999"],
              ["#3", "AUD 599"],
              ["#4", "AUD 399"],
              ["#5", "AUD 399"],
              ["#6", "AUD 199"],
              ["#7", "AUD 199"],
              ["#8", "AUD 199"],
              ["#9", "AUD 199"],
              ["#10", "AUD 199"],
            ].map(([rank, prize]) => (
              <div key={rank} className="grid grid-cols-2 bg-white/[0.04] text-slate-200 text-xs">
                <div className="py-2 text-center border-t border-r border-white/10">{rank}</div>
                <div className="py-2 text-center border-t border-white/10">{prize}</div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="p-4 md:p-5 flex-1 overflow-auto">
          {promo.bullets?.length ? <BulletList bullets={promo.bullets} /> : null}
        </div>
      )}
    </div>
  );
}

export default function Bonuses() {
  return (
    <section id="bonuses" className="py-12">
      <SectionTitle>Bonuses and Promotions</SectionTitle>

      <p className="text-slate-300 leading-relaxed mb-8 text-sm">
        At Ace96au, rewards are built into every step of your journey. Explore weekly commissions, weekly rebates, daily bonuses, special rebate bonuses, VIP promotions, and our monthly deposit ranking competition — there&apos;s always something extra waiting for players.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8">
        {promos.map((promo) => (
          <div
            key={promo.key}
            className={`${promo.variant === "monthly" ? "md:col-span-2" : ""} ${promo.variant === "monthly" ? "" : "h-auto md:h-[540px] lg:h-[560px]"}`}
          >
            <PromoCard promo={promo} />
          </div>
        ))}
      </div>

      {/* Monthly Deposit Ranking Banner removed */}
    </section>
  );
}
